import { render, staticRenderFns } from "./comprogram.vue?vue&type=template&id=261fd654"
import script from "./comprogram.vue?vue&type=script&lang=js"
export * from "./comprogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports